<template>
    <div class="row">
        <div class="col-sm-8">
            <b-card>
                <div slot="header">
                    <i class="icon-graph icons font-1xl"></i><strong> Weer</strong>
                    <small>
                        voorspelling
                    </small>
                </div>
                <form @submit.prevent="retrieveData">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="voorspellingsplaats">Plaats</label>
                                <select type="text" class="form-control" name="voorspellingsplaats" id="voorspellingsplaats" v-model="currentFilter.voorspellingsplaats">>
                                    <template v-for="voorspellingsplaats in voorspellingsplaatsen">
                                        <option :value="voorspellingsplaats.id" :selected="voorspellingsplaats.id == currentFilter.voorspellingsplaats">{{voorspellingsplaats.plaats}}</option>
                                    </template>
                                </select>
                            </div>
                        </div><!--/.col-->
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label">Periode</label>
                                <br />
                                <b-button-group id="periode" name="periode">
                                    <b-button @click="changePeriode(0)" variant="outline-secondary" :pressed="currentFilter.periode == 0">vandaag</b-button>
                                    <b-button @click="changePeriode(1)" variant="outline-secondary" :pressed="currentFilter.periode == 1">morgen</b-button>
                                    <b-button @click="changePeriode(2)" variant="outline-secondary" :pressed="currentFilter.periode == 2">+5 dagen</b-button>
                                </b-button-group>
                                &nbsp;
                            </div>
                        </div><!--/.col-->
                    </div><!--/.row-->
                    <div slot="footer">
                        <b-button type="submit" variant="outline-primary">Tonen</b-button>
                    </div>
                </form>
            </b-card>
        </div><!--/.col-->
    </div><!--/.row-->
</template>

<script>
    export default {
        name: 'FilterForm',
        props: ['voorspellingsplaatsen', 'currentFilter', 'get-forecast-data'],
        methods: {
            retrieveData () {
                this.$emit('get-forecast-data');
            },
            changePeriode (i) {
                this.currentFilter.periode = i;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/weer/FilterFormVoorspelling.vue